// Textes liés à l'authentification
export const AUTH_TEXTS = {
  signIn: 'Se connecter',
  signOut: 'Se déconnecter',
  email: 'Email',
  password: 'Mot de passe',
  invalidCredentials: 'Identifiants invalides',
  sessionExpired: 'Votre session a expiré',
  welcomeBack: 'Bon retour',
  hidePassword: 'masquer le mot de passe',
  showPassword: 'afficher le mot de passe',
  unknownAuthenticationError: 'ERREUR_AUTHENTIFICATION_INCONNUE',
  authenticating: 'Authentification en cours...',
  verifyingAdminAccess: 'Vérification des droits administrateur...'
} as const;